import { CustomStateType, OrderCustomState } from "lib/types/generated/graphql-types"

export const getBlockedOperations = (orderCustomStates: OrderCustomState[]): Set<string> =>
  new Set(
    orderCustomStates
      .filter((s) => s.type === CustomStateType.Blocking)
      .flatMap((s) => s.operations ?? [])
      .filter(Boolean)
  )
